import type { AxiosInstance } from 'axios';
import type {
  AppClientResponse,
  AppClientCreateRequest,
  AppClientKeyResponse,
  AppClientKeyCreateRequest,
  AppClientKeyUpdateRequest,
  AppClientKeyExportResponse,
  EntityId,
} from '@/types';

export const getAppClients = async (
  api: AxiosInstance,
): Promise<AppClientResponse[]> => {
  const resp = await api.get<AppClientResponse[]>(`/user/client`);
  return resp.data;
};

export const createAppClient = async (
  api: AxiosInstance,
  values: AppClientCreateRequest,
): Promise<AppClientResponse> => {
  const resp = await api.post<AppClientResponse>(`/user/client`, values);
  return resp.data;
};

export const getAppClientKeys = async (
  api: AxiosInstance,
  client_id: EntityId,
): Promise<AppClientKeyResponse[]> => {
  const resp = await api.get<AppClientKeyResponse[]>(
    `/user/client/${client_id}/key`,
  );
  return resp.data;
};

export const createAppClientKey = async (
  api: AxiosInstance,
  client_id: EntityId,
  values: AppClientKeyCreateRequest,
): Promise<AppClientKeyExportResponse> => {
  const resp = await api.post<AppClientKeyExportResponse>(
    `/user/client/${client_id}/key`,
    values,
  );
  return resp.data;
};

export const updateAppClientKey = async (
  api: AxiosInstance,
  client_id: EntityId,
  key_id: EntityId,
  values: AppClientKeyUpdateRequest,
): Promise<AppClientKeyResponse> => {
  const resp = await api.put<AppClientKeyResponse>(
    `/user/client/${client_id}/key/${key_id}`,
    values,
  );
  return resp.data;
};

export const deleteAppClientKey = async (
  api: AxiosInstance,
  client_id: EntityId,
  key_id: EntityId,
): Promise<void> => {
  const resp = await api.delete(`/user/client/${client_id}/key/${key_id}`);
  return resp.data;
};

